// extracted by mini-css-extract-plugin
export default {"landscapeWrapper":"LandscapeAboutParticipantOrganism_landscapeWrapper__y95gO","form":"LandscapeAboutParticipantOrganism_form__jj9NZ"};